export const language: any = {
    LabelLogin: "เข้าสู่ระบบ",
    LabelForgotPw: "ลืมรหัสผ่าน",
    LabelSignUp: "สมัครสมาชิก",
    LabelRememberMe: "จดจำฉัน",
    Or: "หรือ",
    Email: "อีเมล",
    Password: "รหัสผ่าน",
    LangKo: "เกาหลี",
    LangEn: "อังกฤษ",
    LangVi: "เวียดนาม",
    LabelCondition: "ยอมรับเงื่อนไข",
    FullAgreement: "ยอมรับทั้งหมด",
    Next: "ถัดไป",
    PrivacyPolicy: `นโยบายความเป็นส่วนตัว <span class="text-[#ff6741]">(จำเป็น)</span>`,
    TermOfUse: `เงื่อนไขการใช้งาน <label class="text-[#ff6741]">(จำเป็น)</label>`,
    VerifyPassword: "ยืนยันรหัสผ่าน",
    PlaceHolderPassword: "กรอกอย่างน้อย 8 ตัวอักษรประกอบด้วยภาษาอังกฤษ, ตัวเลข และสัญลักษณ์",
    DuplicateCheck: "ตรวจสอบซ้ำ",
    LabelIdEmail: "ไอดี (อีเมล)",
    GN_02_MSG_01: "แอปพลิเคชันของคุณล้าสมัย กรุณาอัปเกรดเพื่อใช้งานต่อ",
    AU_02_MSG_01: "กรอกอีเมลในรูปแบบที่ถูกต้อง",
    AU_01_MSG_01: "รหัสผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
    AU_02_MSG_02: "อีเมลนี้มีอยู่ในระบบแล้ว กรุณาใช้อีเมลอื่น",
    AU_02_MSG_03: "อีเมลนี้สามารถใช้งานได้",
    AU_02_MSG_04: "โปรดตรวจสอบความพร้อมของอีเมล",
    AU_02_MSG_05: "กรอกอย่างน้อย 8 ตัวอักษร ประกอบด้วยภาษาอังกฤษ, ตัวเลข และสัญลักษณ์",
    AU_02_MSG_06: "รหัสผ่านไม่ตรงกัน",
    AU_03_MSG_01: "กรอกอีเมลให้ถูกต้อง",
    AU_03_MSG_02: "อีเมลนี้ไม่ได้ลงทะเบียนในระบบ",
    AU_03_MSG_04: "※ รหัสยืนยันถูกส่งไปยังอีเมลที่ลงทะเบียน",
    LabelRegisterComplete: "การสมัครสมาชิกสำเร็จ!",
    LabelLoginToUseService: "กรุณาเข้าสู่ระบบเพื่อใช้งาน",
    LabelDontRememberPassword: "จำรหัสผ่านไม่ได้หรือ?",
    LabelYouCanFindEmail: "ค้นหาได้โดยการยืนยันทางอีเมล",
    LabelPasswordTemporarySendToEmail: "※ รหัสผ่านชั่วคราวจะถูกส่งไปยังอีเมลที่ลงทะเบียนไว้",
    SendVerifyNumber: "ส่งรหัสยืนยัน",
    LabelCheckYourEmailForTemporaryPassword: "ตรวจสอบอีเมลของคุณเพื่อรับรหัสผ่านชั่วคราว",
    PlaceHolderTemporaryPassword: "กรอกรหัสผ่านชั่วคราว",
    LabelTemporaryPassword: "รหัสผ่านชั่วคราว",
    LabelDidntReceiveYourPassword: "ไม่ได้รับรหัสผ่านหรือ?",
    LabelYouCanResendItAfter: "สามารถส่งซ้ำได้หลังจาก",
    LabelYouCanResendAgain: "สามารถส่งซ้ำได้",
    Confirm: "ยืนยัน",
    Resend: "ส่งซ้ำ",
    LabelResetPassword: "ตั้งรหัสผ่านใหม่",
    NewPassword: "รหัสผ่านใหม่",
    ConfirmNewPassword: "ยืนยันรหัสผ่านใหม่",
    PlaceHolderConfirmPassword: "ยืนยันรหัสผ่าน",
    CurrentPassword: "รหัสผ่านปัจจุบัน",
    LanguageSetting: "ตั้งค่าภาษา",
    LeaveMembership: "ยกเลิกการเป็นสมาชิก",
    LabelConfirmPasswordToLeaveMemberShip: "ยืนยันรหัสผ่านเพื่อยกเลิกการเป็นสมาชิก",
    LabelConfirmPasswordMeansYouAgreeAllContent: "การยืนยันรหัสผ่านหมายถึงคุณยอมรับเนื้อหาทั้งหมด",
    LabelCancelMembership: "ยกเลิกการเป็นสมาชิก",
    LabelBeforeLeaveYouCheckedContent: "ก่อนออก โปรดอ่านและยืนยันตามข้อกำหนด",
    LabelAfterLeaveAllInfoWillRemove: "หลังจากออก ข้อมูลทั้งหมดจะถูกลบและไม่สามารถกู้คืนได้",
    LabelIHaveReadAndAgreeContent: "ฉันได้อ่านและยอมรับเนื้อหาทั้งหมดแล้ว",
    ToUnsubscribe: "ยกเลิกการสมัคร",
    LabelWouldYouWantLogout: "คุณต้องการออกจากระบบหรือไม่?",
    ChangePassword: "เปลี่ยนรหัสผ่าน",
    Menu: "เมนู",
    MenuLanguageSettings: "การตั้งค่าภาษา",
    MenuPrivacyPolicy: "นโยบายความเป็นส่วนตัว",
    MenuLogout: "ออกจากระบบ",
    MenuLeaveMembership: "ยกเลิกการเป็นสมาชิก",
    LabelAreYouSureLeaveMembership: "คุณแน่ใจว่าต้องการยกเลิกการเป็นสมาชิกหรือไม่?",
    LabelIfLeaveMembershipAllInfoWillRemove: "หากยกเลิก ข้อมูลทั้งหมดจะถูกลบและไม่สามารถกู้คืนได้",
    LabelPrivacyPolicy: "นโยบายความเป็นส่วนตัว",
    LabelTermOfUse: "เงื่อนไขการใช้งาน",
    MI_02_MSG_01: "รหัสผ่านปัจจุบันไม่ถูกต้อง",
    LabelModalLogin: `เพื่อใช้ฟังก์ชันนี้<br/>กรุณาเข้าสู่ระบบหรือสมัครสมาชิก`,
    LabelIdLogin: "เข้าสู่ระบบด้วย ID",
    LabelSnsApple: "เข้าสู่ระบบด้วย Apple",
    LabelSnsFacebook: "เข้าสู่ระบบด้วย Facebook",
    LabelSnsGoogle: "เข้าสู่ระบบด้วย Google",
    LabelItemLogin: "Hey! หากต้องการสำรวจฟีเจอร์หลากหลายกับ Cooker โปรดเข้าสู่ระบบหรือสมัครสมาชิก",
    LabelSnsEmail: "เข้าสู่ระบบด้วยอีเมล",
    LoadingLogin: "ๆ กรุณารอสักครู่",
    MenuNotificationSettings: "การตั้งค่าการแจ้งเตือน", //menu
};


